module.exports = __webpack_public_path__ + "img/rocktech.ca84b14a.svg";